import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileFrameboardComponent, templateContentDirective } from './profile-frameboard.component';
import { RouterModule } from '@angular/router';
import { MesaPartesFrameboardModule } from '../mesa-partes-frameboard/mesa-partes-frameboard.module';
import { FrameBoardModule } from '../frameboard/frameboard.module';

@NgModule({
  declarations: [ProfileFrameboardComponent, templateContentDirective],
  exports: [ProfileFrameboardComponent],
  imports: [
    CommonModule,
    RouterModule,
    MesaPartesFrameboardModule,
    FrameBoardModule
  ],
})
export class ProfileFrameboardModule { }
